import { CUSTOMER_USER_DETAIL, CUSTOMER_USER_DETAIL_SUCCESS, CUSTOMER_USER_DETAIL_ERROR, CUSTOMER_USER_DETAIL_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CustomerUserDetail = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_USER_DETAIL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CUSTOMER_USER_DETAIL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CUSTOMER_USER_DETAIL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CUSTOMER_USER_DETAIL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CustomerUserDetail;
